import { render, staticRenderFns } from "./Albums.vue?vue&type=template&id=4e0bfc34&scoped=true&"
import script from "./Albums.vue?vue&type=script&lang=js&"
export * from "./Albums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0bfc34",
  null
  
)

export default component.exports